var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./vertical-scroll.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4b22edf2\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./vertical-scroll.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/VerticalScroll/vertical-scroll.vue.html
// module id = 04/W
// module chunks = 2